module.exports = __webpack_public_path__ + "img/france.00d3ca1d.svg";